import { render, staticRenderFns } from "./ImportProductsToInvoice.vue?vue&type=template&id=bccfd590&scoped=true&"
import script from "./ImportProductsToInvoice.vue?vue&type=script&lang=js&"
export * from "./ImportProductsToInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ImportProductsToInvoice.vue?vue&type=style&index=0&id=bccfd590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccfd590",
  null
  
)

export default component.exports